import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { StackedBarChart } from '../../../../../../../../../shared/components/Charts/components/StackedBar';

export default function IncidenciasPorTipoChart({
    chart
}) {
    const [tipoIncidenciaId, setTipoIncidenciaId] = useState(-1);
    const tiposIncidencia = useSelector(state => state.tipo_incidencias);

    const incidenciasTipoChart = useMemo(() => {
        if (!chart) {
            return chart;
        }

        if (parseInt(tipoIncidenciaId) === -1) {
            return chart;
        }

        return {
            ...chart,
            datasets: (chart.datasets || []).filter(
                dataset => parseInt(dataset.tipo_id) === parseInt(tipoIncidenciaId)
            )
        };
    }, [chart, tipoIncidenciaId]);

    return (
        <div className="w-100 d-flex flex-wrap align-items-center justify-content-between">
            <h1>Incidencias por tipo</h1>

            <div className="w-100 d-flex flex-column mt-3">
                <div className="d-flex align-items-center mb-2">
                    <select
                        id="tipo-incidencia"
                        value={tipoIncidenciaId}
                        onChange={(e) => setTipoIncidenciaId(e.target.value)}
                    >
                        <option value={-1}>Todos los tipos</option>
                        {(tiposIncidencia || []).map(tipo => (
                            <option key={'tipo-incidencia-' + tipo.id} value={tipo.id}>
                                {tipo.nombre}
                            </option>
                        ))}
                    </select>
                </div>

                <StackedBarChart dataset={incidenciasTipoChart} />
            </div>
        </div>
    );
}
